export default __webpack_public_path__ + "static/media/yellowTheme-boy.4579de4e.svg";